import * as ModalMutationTypes from './modal.types.js';

export const state = {
  contactModalOpen: false
};

export const getters = {
  isContactModalOpen(state) {
    return state.contactModalOpen;
  }
};

export const actions = {
  [ModalMutationTypes.OPEN_CONTACT](store){
    store.commit(ModalMutationTypes.OPEN_CONTACT);
  },
  [ModalMutationTypes.CLOSE_CONTACT](store){
    store.commit(ModalMutationTypes.CLOSE_CONTACT);
  }
};

export const mutations = {
  [ModalMutationTypes.OPEN_CONTACT](state){
    state.contactModalOpen = true;
  },
  [ModalMutationTypes.CLOSE_CONTACT](state){
    state.contactModalOpen = false;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/modal/modal.store.js